import { request } from './core'

export const submissionApi = {
  submissionPreflight: (slug: string) =>
    request<{
      checks: { name: string; passed: boolean; detail: string; target: string | null }[]
      all_pass: boolean
    }>(`/api/assessments/${slug}/submission/preflight`),

  markSubmitted: (slug: string, submitted: boolean, submittedAt?: string, revision?: number) =>
    request<{ status: string; submitted_at: string | null; revision: number }>(
      `/api/assessments/${slug}/submission/submit`,
      { method: 'POST', body: JSON.stringify({ submitted, submitted_at: submittedAt ?? null }) },
      { ifMatch: revision },
    ),
}
